import React, { useContext } from 'react';
import { breakpoint, Button, StepperContext } from '@digitools/honest-ui';
import styled from 'styled-components';
import useTranslate from '../../../hooks/useTranslate';
import { AsText } from '../constants/Text';
import useAsDataContext from '../hooks/useAsDataContext';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import useTealium from 'src/hooks/useTealium';
import useExperience from 'src/hooks/useExperience';
import { Experience } from 'src/types/Experience';
// Mobile first: stacked, full-width buttons with Continue/Submit above Back; centered side by
// side (Back on the left) from the md breakpoint. The DOM keeps Back first so tab order matches
// the desktop layout.
const StyledDiv = styled('div') `
  margin-top: var(--spacing-xs);
  margin-left: 0;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: var(--spacing-xl-2);
  .stepper-button {
    width: 100%;
    max-width: 80%;
  }
  @media (min-width: ${breakpoint.md}) {
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    .stepper-button {
      width: auto;
      max-width: none;
      min-width: 12rem;
    }
  }
`;
/* Reusable container for stepper button formatting at the bottom of each interview page */
const StepperButtons = ({ type = 'continue', firstStep, last, lastButton, suppressNext, onClickBack, onClickNext, analyticsPageName, }) => {
    const { t } = useTranslate();
    const { setSubmitErrors, submitErrors } = useAsDataContext();
    const stepper = useContext(StepperContext);
    const { experience } = useExperience();
    const { trackEvent } = useTealium();
    const onNext = () => {
        if (!suppressNext) {
            stepper.next();
        }
    };
    const handleBackButtonClick = () => {
        if (experience === Experience.EMPLOYER) {
            if (analyticsPageName == 'about you') {
                analyticsPageName = "about your employee";
            }
            if (analyticsPageName == 'about accommodation') {
                analyticsPageName = "about your employee's accommodation";
            }
        }
        trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.BUTTON,
            event_name: 'back',
            event_type: TEALIUM_EVENT.EVENT_TYPE.ACCOMMODATION,
            event_version: analyticsPageName == 'review' ? 'review your request and submit' : analyticsPageName,
        });
        if (submitErrors) {
            setSubmitErrors(false);
        }
        if (onClickBack) {
            onClickBack();
        }
        stepper.back();
        window.scrollTo(0, 0);
    };
    const handleContinueButtonClick = () => {
        if (submitErrors) {
            setSubmitErrors(false);
        }
        if (onClickNext) {
            onClickNext();
        }
        onNext();
        window.scrollTo(0, 0);
    };
    const label = type == 'continue' ? t(AsText.continue) : t(AsText.submit);
    return (<StyledDiv data-testid='stepper-buttons'>
      {!firstStep && (<Button data-testid='stepper-back' type={'secondary'} label={t(AsText.backButton)} onClick={() => handleBackButtonClick()} className='stepper-button'/>)}

      {!last && (<Button type={'primary'} htmlType={'submit'} label={label} data-testid='stepper-next' onClick={() => handleContinueButtonClick()} className='stepper-button'/>)}

      {lastButton}
    </StyledDiv>);
};
export default StepperButtons;
